import axios from '../../axios';
import {
  ADD_GL_GROUP,
  DELETE_GL_GROUP,
  UPDATE_GL_GROUP,
  GET_GL_GROUP,
  GET_GL_GROUPS,
  GET_GL_GROUPS_ALL,
  GET_ONE_GL_GROUP
} from '../types';
import { toast } from 'react-toastify';

export const getGLGroups = (params) => async (dispatch) => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_ADMIN_URL}/gl/all`, {
      params,
    });

    if (res.data.code === 1) {
      dispatch({
        type: GET_GL_GROUPS,
        payload: {
          data: res.data.data || [],
          pagination: res.data.pagination || {},
          totalCount: res.data.totalCount || 0, 
        },
      });
    }
    if (res.data.code === 2) {
      setTimeout(() => {
        toast.warn(res.data.message);
      }, 1000);
    }
  } catch (err) {
    if (err.response?.data?.message) {
      toast.error(err.response?.data?.message);
    }
  }
};

export const getGLGroupsAllDropdown = () => async (dispatch) => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_ADMIN_URL}/gl/all`);

    if (res.data.code === 1) {
      dispatch({
        type: GET_GL_GROUPS_ALL,
        payload: res.data.data,
        totalCount: res.data.totalCount,
      });
    }
    if (res.data.code === 2) {
      setTimeout(() => {
        toast.warn(res.data.message);
      }, 1000);
    }
  } catch (err) {
    if (err.response.data.message) {
      toast.error(err.response.data.message);
    }
  }
};

export const getGLGroupId = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`/gl/${id}`);

    if (res.data.code === 1) {
      dispatch({ type: GET_GL_GROUP, payload: res.data.data });
    }
    if (res.data.code === 2) {
      setTimeout(() => {
        toast.warn(res.data.message);
      }, 1000);
    }
  } catch (err) {
    if (err.response.data.message) {
      toast.error(err.response.data.message);
    }
    // console.error('Failed to add customer. Please try again.');
  }
};

export const addGLGroup = (formData) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_ADMIN_URL}/gl/add`,
      formData,
    );

    if (res.data.code === 1) {
      dispatch({ type: ADD_GL_GROUP, payload: res.data.data });
      setTimeout(() => {
        toast.success('GL Group added successfully!');
      }, 1000);
    }
    if (res.data.code === 2) {
      setTimeout(() => {
        toast.warn(res.data.message);
      }, 1000);
    }
  } catch (err) {
    if (err.response.data.message) {
      toast.error(err.response.data.message);
    }
  }
};

export const updateGLGroup = (formData) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_ADMIN_URL}/gl/update`,
      formData,
    );

    if (res.data.code === 1) {
      dispatch({ type: UPDATE_GL_GROUP, payload: res.data.data });

      setTimeout(() => {
        toast.success('GL Group updated successfully!');
      }, 1000);
    }
    if (res.data.code === 2) {
      setTimeout(() => {
        toast.warn(res.data.message);
      }, 1000);
    }
  } catch (err) {
    if (err.response.data.message) {
      toast.error(err.response.data.message);
    }
  }
};

export const deleteGLGroup = (id) => async (dispatch) => {
  try {
    if (!id) {
      toast.error('Please select any record');
      return false;
    }
    const res = await axios.post(
      `${process.env.REACT_APP_ADMIN_URL}/gl/delete/${id}`,
    );
    if (res.data.code === 1) {
      dispatch({ type: DELETE_GL_GROUP, payload: { id } });
      toast.success('GL Group deleted successfully!');
    }
    if (res.data.code === 2) {
      toast.warn(res.data.message);
    }
  } catch (err) {
    if (err.response.data.message) {
      toast.error(err.response.data.message);
    }
    // toast.error('Failed to delete Customer. Please try again.');
  }
};

export const updateGLGroupStatus = (data) => async (dispatch) => {
  const res = await axios.post(
    `${process.env.REACT_APP_ADMIN_URL}/gl/update/status`,
    data,
  );
  if (res.data.code === 1) {
    dispatch({ type: UPDATE_GL_GROUP, payload: res.data.data });
    toast.success('Status updated successfully!');
  }
  if (res.data.code === 2) {
    toast.warn(res.data.message);
  }
  return res.data.code;
};

export const getSingleLedger = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`/gl/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: GET_ONE_GL_GROUP, payload: res.data.data });
    }
  } catch (err) {
    console.error('Failed to get item by finish item. Please try again.');
    if (err.response.data.message) {
      toast.error(err.response.data.message);
    }
  }
};